import { render, staticRenderFns } from "./ValidatedTable.vue?vue&type=template&id=a8779420&scoped=true"
import script from "./ValidatedTable.vue?vue&type=script&lang=js"
export * from "./ValidatedTable.vue?vue&type=script&lang=js"
import style0 from "./ValidatedTable.vue?vue&type=style&index=0&id=a8779420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8779420",
  null
  
)

export default component.exports